import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { SessionService } from '../../shared/services/session.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';


export const SelectLocationGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) => {
        const router: Router = inject(Router);
        const session: SessionService = inject(SessionService);
        const authService: AuthService = inject(AuthService);

        let sessionValid = true;
        let service: string = route.queryParams['service'];
        let userID: string = route.queryParams['zone'];
        let token: string = route.queryParams['token'];
        let type: string = route.queryParams['type'];
        let viewOnly: boolean = (route.queryParams['vo'] !== undefined)? route.queryParams['vo'] === 'true' : session.viewOnly;


        if (!service && !session.service && !viewOnly) {
            // if we don't have a service to schedule for the user can't proceed
            sessionValid = false;
        }
        if (!userID && !session.user && !viewOnly) {
            // if we don't have a user to schedule for then we can't proceed
            sessionValid = false;
        }
        if (!type && !session.appointmentType && !viewOnly) {
            // if we don't know what type of appointment we are making then we don't know how to set up the session
            sessionValid = false;
        }

       // If there was a token parameter or a token in the session authtenticated with cookie should be false
       if (token || session.token) {
            session.authenticatedViaCookie = false;
            if (!sessionValid) {
                router.navigate(['/']);
            }

            return of(sessionValid);
            // return sessionValid;
        } else {
            return authService.isAuthenticated().pipe(map((res) => {
                session.authenticatedViaCookie = res;

                if (!session.authenticatedViaCookie && !token && !session.token && !viewOnly) {
                    sessionValid = false;
                }

                if (!sessionValid) {
                    router.navigate(['/']);
                }

                return sessionValid;
            }));
        }
    };
